import React from "react";

var Component = function (props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9h-7.644l1.472-3.889c.377-.996.042-2.135-.802-2.73-.964-.679-2.264-.427-2.937.569L6 9v9a4 4 0 0 0 4 4h6.516a3.999 3.999 0 0 0 3.573-2.202L22 16v-5a2 2 0 0 0-2-2zM2 9v12"
  })));
};

Component.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
Component.displayName = "thumbs-up";
export default Component;